import { LocalStorage as SessionStorage } from 'quasar'
import axios from 'axios'
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { signInWithCustomToken } from "firebase/auth";
import moment from "moment";

export function userValidate({ context, commit }, payload) {
  return new Promise((resolve, reject) => {
      axios
          .post("auth0/user/validate", {email: payload})
          .then(response => {
              resolve(response.data)
          })
          .catch(err => {
              reject(err)
          })
  })
}

export function resendVerificationMail({ context, commit }, payload) {
  return new Promise((resolve, reject) => {
      axios
          .post("auth0/user/resendverificationmail", {email: payload})
          .then(response => {
              resolve(response.data)
          })
          .catch(err => {
              reject(err)
          })
  })
}

export function auth0Login({ context, commit }, payload) {
    let accessToken = JSON.parse(SessionStorage.getItem('access_token'));
    return new Promise((resolve, reject) => {
        axios
            .post("auth0/user/login", { accessToken: accessToken })
            .then(response => {
                if(response.data.data.status != "Pending") {
                    SessionStorage.set('token', JSON.stringify(response.data.data.token))
                    commit('setAuthUser', response.data.data)
                }else{
                    SessionStorage.set('registration_token', JSON.stringify(response.data.data.token))
                }
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getCustomFirebaseToken({ state, context, commit }) {
    return new Promise((resolve, reject) => {
        axios
            .post("testcustomtoken", { user_id: state.authUser._id })
            .then(response => {
                commit("setFirebaseToken", response.data)
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// user logout function
export function logout({ context, state, commit }) {

    return new Promise((resolve, reject) => {
        axios
            .post("user/logout")
            .then(response => {
                resolve(true)
            })
            .catch(err => {
                resolve(true) // even it's err send resolve, don't want any error on this function
            })
            .finally(() => {
                // Logout
                this.$auth.logout({ returnTo: `${window.location.origin}/logout` });
                SessionStorage.clear();

                // remove authUser from state
                commit('resetAuthUser')

                //reset other states
                this.dispatch('home/resetStore')
                this.dispatch('user/resetStore')
                this.dispatch('tracks/resetStore')
                this.dispatch('registration/resetStore')
                this.dispatch('miscellaneous/resetStore')
                this.dispatch('events/resetStore')
                this.dispatch('coachingblock/resetStore')
                this.dispatch('auth/resetStore')
            })
    })
}


// Check User is authorized or not
export function checkAuthUser({ context, state }) {

    return new Promise((resolve, reject) => {
        let token = JSON.parse(SessionStorage.getItem('token'))
        let authUserData = JSON.parse(SessionStorage.getItem('authUserData'))
        if (token === null) {
            reject(false)
        } else {
            if (state.authUser._id === undefined || authUserData === null) {

                this.dispatch('auth/fetchAuthUser')
                    .then(res => {
                        resolve(res.data.data.token)
                    })
                    .catch(err => {
                        console.error("ERROR fetchAuthUser", err)
                    })
            } else
                resolve(token)
        }
    })
}

export function getAuthUserID({ state }) {
    return state.authUser._id
}


export function fetchAuthUser({ state, commit }) {
    return new Promise((resolve, reject) => {
        axios
            .get("/user")
            .then(response => {
                SessionStorage.set('authUserData', JSON.stringify(response.data.data))

                if(response.data.data.timezone) {
                  this.$timezone = response.data.data.timezone
                }else {
                  this.$timezone = moment.tz.guess() == "Asia/Calcutta"
                  ? "Asia/Kolkata"
                  : moment.tz.guess();
                }
                commit('setAuthUser', response.data.data)
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })

    })
}

export function setPassword({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
        axios
            .post("/user/password/set", state.setPassword)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function checkRedirectStatus({ state, commit }, payload) {
  return new Promise((resolve, reject) => {
      axios
          .post("/user/checkredirectstatus", {token: payload})
          .then(response => {
              resolve(response.data)
          })
          .catch(err => {
              reject(err)
          })
  })
}


export function resetStore({ commit, store }) {
    commit('resetStore')
}

